import {z} from 'zod';

import {BaseVoidRequestSchema, BaseVoidResponseSchema} from '@dms/api/shared';

/**
 * Base
 */
export const BaseLabourUnitSchema = z.object({
  labourUnitId: z.string(),
  name: z.string(),
  isActive: z.boolean(),
  isDefault: z.boolean(),
});
export type BaseLabourUnit = z.infer<typeof BaseLabourUnitSchema>;

/**
 * GET
 */
export const GetLabourUnitsRequestSchema = BaseVoidRequestSchema;
export type GetLabourUnitsRequest = z.infer<typeof GetLabourUnitsRequestSchema>;

export const GetLabourUnitsResponseSchema = z.array(BaseLabourUnitSchema);
export type GetLabourUnitsResponse = z.infer<typeof GetLabourUnitsResponseSchema>;

export const GetLabourUnitRequestSchema = z.object({
  labourUnitId: z.string(),
});
export type GetLabourUnitRequest = z.infer<typeof GetLabourUnitRequestSchema>;

export const GetLabourUnitResponseSchema = BaseLabourUnitSchema;
export type GetLabourUnitResponse = z.infer<typeof GetLabourUnitResponseSchema>;

/**
 * POST
 */
export const PostLabourUnitRequestSchema = z.object({
  name: z.string(),
});
export type PostLabourUnitRequest = z.infer<typeof PostLabourUnitRequestSchema>;

export const PostLabourUnitResponseSchema = z.object({
  labourUnitId: z.string(),
});
export type PostLabourUnitResponse = z.infer<typeof PostLabourUnitResponseSchema>;

/**
 * PATCH
 */
export const PatchLabourUnitRequestSchema = z.object({
  labourUnitId: z.string(),
  body: z
    .object({
      name: z.string(),
    })
    .optional(),
});
export type PatchLabourUnitRequest = z.infer<typeof PatchLabourUnitRequestSchema>;

export const PatchLabourUnitResponseSchema = BaseVoidResponseSchema;
export type PatchLabourUnitResponse = z.infer<typeof PatchLabourUnitResponseSchema>;

/**
 * DELETE
 */
export const DeleteLabourUnitRequestSchema = z.object({
  labourUnitId: z.string(),
});
export type DeleteLabourUnitRequest = z.infer<typeof DeleteLabourUnitRequestSchema>;

export const DeleteLabourUnitResponseSchema = BaseVoidResponseSchema;
export type DeleteLabourUnitResponse = z.infer<typeof DeleteLabourUnitResponseSchema>;

/**
 * POST
 */
export const SetLabourUnitAsDefaultRequestSchema = z.object({
  labourUnitId: z.string(),
});
export type SetLabourUnitAsDefaultRequest = z.infer<typeof SetLabourUnitAsDefaultRequestSchema>;

export const SetLabourUnitAsDefaultResponseSchema = BaseVoidResponseSchema;
export type SetLabourUnitAsDefaultResponse = z.infer<typeof SetLabourUnitAsDefaultResponseSchema>;
